{
  "generic": "Хатои ногаҳонӣ рӯй дод",
  "network": "Хатои шабака. Пайвастро санҷед.",
  "notFound": "Саҳифа ёфт нашуд",
  "forbidden": "Иҷозат нест",
  "tryAgain": "Дубора кӯшиш"
}
